import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="flex min-h-[400px] flex-col items-center justify-center text-center">
      <p className="text-ink-700 text-7xl font-bold tabular-nums">404</p>
      <p className="text-ink-100 mt-3 text-lg font-semibold">Página não encontrada</p>
      <Link
        to="/dashboard"
        className="bg-brand-500 hover:bg-brand-600 mt-6 inline-flex rounded-lg px-5 py-2.5 text-sm font-semibold text-white"
      >
        Voltar pro dashboard
      </Link>
    </div>
  );
}
